{
  "brand": "VBB PLAY",
  "tagline": "Premium oyun platforması",
  "loading": "Yüklənir…",
  "retry": "Yenidən cəhd et",
  "close": "Bağla",
  "search": "Axtar",
  "seeAll": "Hamısına bax",
  "comingSoon": "Tezliklə",
  "currency": "AZN",
  "language": "Dil",
  "selectLanguage": "Dil seçin",
  "offlineHint": "Bağlantı yoxlanılır",
  "footerRights": "© {{year}} VBB PLAY. Bütün hüquqlar qorunur.",
  "footerSupport": "Dəstək",
  "heroEyebrow": "PLAY BEYOND LIMITS",
  "heroTitle": "Böyük oyunlar, cəsarətli uduşlar",
  "heroSubtitle": "Limitləri aş — premium lobbi, təhlükəsiz kassa və seçilmiş oyun kataloqu.",
  "heroCta": "İndi oyna",
  "promoFallbackTitle": "Xoş gəldin bonusu",
  "promoFallbackSubtitle": "Bonus və VIP proqramı hazırlanır. Kampaniyalar aktiv olanda iddia edin.",
  "promoFallbackCta": "İndi götür",
  "promoFilter_all": "Hamısı",
  "promoFilter_welcome": "Xoş gəldin",
  "promoFilter_casino": "Kazino",
  "promoFilter_sports": "İdman",
  "promoFilter_vip": "VIP",
  "login": "Giriş",
  "storyBonuses": "Bonuslar",
  "storyVip": "VIP",
  "storyCashback": "Cashback",
  "storyCrypto": "Kripto",
  "bonusSelectTitle": "Bonus seç",
  "continue": "Davam et",
  "supportWelcome": "VBB PLAY-ə xoş gəldiniz",
  "supportPrechat": "Dialoqa başlamazdan əvvəl əlaqə məlumatlarınızı və sualınızı qeyd edin.",
  "supportEmail": "E-poçt",
  "supportName": "Ad",
  "supportMessage": "Mesaj",
  "supportConsent": "Şəxsi məlumatların işlənməsinə razılıq verirəm.",
  "startDialogue": "Dialoqa başlamaq",
  "attach": "Qoş",
  "send": "Göndər",
  "support247": "Dəstək 24/7",
  "supportInvite": "Operatorlarımız kömək etməyə hazırdır.",
  "contactSupport": "Dəstəklə əlaqə saxla",
  "infoSection": "Məlumat",
  "referral": "Tövsiyə",
  "liveSports": "Canlı",
  "prematch": "Prematch",
  "fiatMethods": "Fiat",
  "fiatMethodsHint": "Kart, M10, Terminal",
  "cryptoMethodsHint": "Kassado dəstəklənən kriptovalyutalar",
  "personalInfo": "Şəxsi məlumatlar",
  "contactInfo": "Əlaqə məlumatları",
  "displayName": "Ad",
  "notAvailable": "Mövcud deyil",
  "phone": "Telefon",
  "profileEditHint": "Ad, doğum tarixi və cins hesabınızda saxlanır.",
  "myProfile": "Profilim",
  "securitySettings": "Təhlükəsizlik",
  "rewardCenter": "Mükafat mərkəzi",
  "notificationsTitle": "Bildirişlər",
  "markAllRead": "Hamısını oxunmuş et",
  "marketingOptIn": "Promo bildirişləri almaq",
  "emptyNotifications": "Bildiriş yoxdur",
  "notificationsUnavailable": "Hadisə bildirişləri burada görünür. Heç nə uydurulmur.",
  "open": "Aç",
  "protectionTitle": "Hesab qorunması",
  "coolingOff": "Soyutma müddəti",
  "selfExclude": "Özünü məhdudlaşdır",
  "requestClosure": "Hesabın bağlanmasını istə",
  "helpSupport": "Kömək və dəstək",
  "promoCode": "Promo kod",
  "redeem": "Aktivləşdir",
  "bonusHistory": "Bonus tarixçəsi",
  "promoLoginRequired": "Kodu aktivləşdirmək üçün daxil olun.",
  "promoSuccess": "{{amount}} AZN hesabınıza əlavə olundu",
  "promo_invalid_code": "Bu kod etibarsızdır.",
  "promo_campaign_expired": "Bu kampaniyanın müddəti bitib.",
  "promo_campaign_inactive": "Bu kampaniya aktiv deyil.",
  "promo_campaign_not_started": "Bu kampaniya hələ başlamayıb.",
  "promo_per_user_limit": "Siz bu kodu artıq istifadə etmisiniz.",
  "promo_unique_user_limit": "Kampaniyanın oyunçu limiti dolub.",
  "promo_usage_limit": "Bu kampaniya üçün istifadə qalmayıb.",
  "promo_not_eligible": "Bu kampaniya üçün uyğun deyilsiniz.",
  "promo_minimum_deposit_not_satisfied": "Uyğun depozit tələb olunur.",
  "promo_budget_exhausted": "Kampaniyanın büdcəsi bitib.",
  "promo_too_many_requests": "Həddən artıq cəhd. Bir az sonra yenidən yoxlayın.",
  "promo_zero_reward": "Bu kampaniyanın burada nağd mükafatı yoxdur.",
  "promo_redeem_failed": "Kodu aktivləşdirmək mümkün olmadı.",
  "storyPromo": "Promo kod",
  "liveSupport": "Canlı dəstək",
  "sportsUnavailable": "İdman mərc hazırda mövcud deyil. Kazino oyunları açıqdır.",
  "linked": "Qoşulub",
  "notLinked": "Qoşulmayıb",
  "loadFailed": "Yüklənmədi",
  "unavailableTitle": "Hazır deyil",
  "vipUnavailable": "VIP səviyyələri hələ konfiqurasiya olunmayıb.",
  "givenName": "Ad",
  "familyName": "Soyad",
  "dateOfBirth": "Doğum tarixi",
  "gender": "Cins",
  "genderMale": "Kişi",
  "genderFemale": "Qadın",
  "genderOther": "Digər",
  "genderPreferNot": "Bildirmək istəmirəm",
  "saveProfile": "Profili saxla",
  "profileSaved": "Profil yadda saxlandı",
  "profileSaveFailed": "Profil saxlanılmadı",
  "identityLockedNotice": "Şəxsi məlumatlarınız qeydə alınıb. Dəyişiklik etmək üçün canlı dəstəyə müraciət edin.",
  "identityChangeRequest": "Dəyişiklik üçün müraciət et",
  "identityChangeReason": "Dəyişiklik səbəbi",
  "identitySubmitRequest": "Müraciəti göndər",
  "identityChangePending": "Müraciətiniz baxışdadır.",
  "identityChangeSubmitted": "Müraciət göndərildi. Canlı dəstək sizinlə əlaqə saxlayacaq.",
  "identityChangeFailed": "Müraciət göndərilmədi.",
  "identityNoChanges": "Dəyişiklik tapılmadı.",
  "createdAt": "Hesab yaradılıb",
  "ageIneligible": "Bu doğum tarixi hüquqi yaşdan aşağıdır. Real pul oyunu bağlı qalır.",
  "rateOperator": "Söhbəti qiymətləndirin",
  "ratingComment": "İstəyə bağlı rəy",
  "submitRating": "Qiymət göndər",
  "ratingThanks": "Qiymət üçün təşəkkürlər",
  "footerRules": "Qaydalar",
  "footerPrivacy": "Məxfilik",
  "rulesLink": "Qaydalar və siyasətlər",
  "footerLegalTitle": "Hüquqi məlumat",
  "footerLegalDraftBadge": "QARALAMA",
  "footerLegalDraftNotice": "Aşağıdakı rekvizitlər yalnız lokal hüquqi qaralamadır. Şirkət qeydiyyatı və lisenziya təsdiqlənənə qədər onların doğrulandığı, VBB PLAY-in lisenziyalı olduğu və ya bütün qumar fəaliyyətlərini qanuni həyata keçirmək səlahiyyətinə malik olduğu iddia edilmir.",
  "footerCompanyLabel": "Şirkət",
  "footerCompanyName": "Vbb Play Byte Lab Sociedad de Responsabilidad Limitada",
  "footerCountryLabel": "Qeydiyyat ölkəsi",
  "footerCountryValue": "Kosta-Rika",
  "footerRegNumberLabel": "Qeydiyyat nömrəsi",
  "footerRegNumberValue": "2-101-918934",
  "footerAddressLabel": "Hüquqi ünvan",
  "footerAddressValue": "Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu kinoteatrlarından 200 metr cənubda, Seiba küçəsi, Centro Corporativo EBC, onuncu mərtəbə, Invicta Legal ofisi.",
  "footerLicenseNumberLabel": "Təqdim edilən lisenziya nömrəsi",
  "footerLicenseNumberValue": "ALSI-207508070-FI1",
  "footerLicenseJurisdictionLabel": "Təqdim edilən lisenziya yurisdiksiyası",
  "footerLicenseJurisdictionValue": "Anjuan, Komor Adaları İttifaqı",
  "footerLegalAria": "Hüquqi məlumat",
  "footerLegalStatement": "© 2026 VBB Play. vbbplay.com Kosta-Rikada qeydiyyatdan keçmiş Vbb PLay Byte Lab Sociedad de Responsabilidad Limitada şirkətinə məxsusdur və onun tərəfindən idarə olunur, qeydiyyat nömrəsi 2-101-918934, hüquqi ünvanı: Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu kinoteatrlarından 200 metr cənubda, Seiba küçəsi, Centro Corporativo EBC, onuncu mərtəbə, Invicta Legal ofisi. vbbplay.com Komor Adaları İttifaqının Avtonom Anjuan Adası Hökuməti tərəfindən lisenziyalaşdırılıb və tənzimlənir və ALSI-207508070-FI1 nömrəli lisenziya əsasında fəaliyyət göstərir. VbbPlay.com bütün tənzimləyici tələblərdən keçmişdir və hər cür qumar oyunları və mərc əməliyyatlarını qanuni şəkildə həyata keçirməyə səlahiyyətlidir.",
  "back": "Geri",
  "rulesSelectAria": "Hüquqi sənəd seçin",
  "scrollToTop": "Yuxarı qayıt",
  "footerAria": "Sayt altlığı",
  "footerLiveCasino": "Canlı kazino",
  "footerProviders": "Provayderlər",
  "footerFastGames": "Sürətli oyunlar",
  "footerEsports": "Kiberidman",
  "footerTournaments": "Turnirlər",
  "footerPartnership": "Tərəfdaşlıq proqramı",
  "footerTechSupport": "Texniki dəstək",
  "footerSupportSecurity": "Dəstək və təhlükəsizlik",
  "footerSocial": "Sosial şəbəkələr",
  "footerSocialPending": "Rəsmi sosial hesablar təsdiqlənəndən sonra burada açılacaq.",
  "footerAgeHint": "Yalnız 18 yaşdan yuxarı",
  "footerLegalAccordionTitle": "Hüquqi məlumat"
}
